<template>
    <div class="main_container">
        <van-popover id="drop_down_id" v-model:show="showPopover" :actions="actions">
            <template #reference>
                <van-row class="dropDown_container"
                    :style="{ border: !showPopover ? '1px solid rgba(255, 255, 255, 0.25)' : '1px solid rgba(255, 255, 255, 1)' }">
                    <van-col span="22">{{ selectAction.text }}</van-col>
                    <van-col span="2">
                        <div v-if="!showPopover" class="dropDown"> <img src="@/assets/agent/sanjiao_bai.png" alt="">
                        </div>
                        <div v-if="showPopover" class="dropDownUp"> <img src="@/assets/agent/sanjiao.png" alt=""></div>
                    </van-col>
                </van-row>
            </template>
            <template #default>
                <van-row class="option_card">
                    <van-col span="24" class="option_row"
                        :style="{ background: selectAction.id == item.id ? '#F0A853' : '' }" v-for="item in actions"
                        :key="item.text" @click="onSelect(item)">
                        {{ item.text }}</van-col>
                </van-row>
            </template>
        </van-popover>
    </div>

</template>

<script setup lang="ts">
import { ref, defineEmits } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const showPopover = ref(false);

const actions = ref([
    { text: t('agent.directRegistration'), id: 1 },
    { text: t('agent.commissionTeam'), id: 2 },
]);
const selectAction = ref(actions.value[0])
const emits = defineEmits(['setActiveType'])
const onSelect = (item: any) => {
    selectAction.value = item
    emits('setActiveType', selectAction.value.id)
    setTimeout(() => { showPopover.value = false }, 200)
}
</script>

<style scoped>
.main_container>>>.van-popover__wrapper {
    display: flex;
}

.dropDown_container {
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.25);
    width: 100%;
    padding: 5px 10px;
    color: #FFFFFF;
    font-weight: 700;
    font-size: 15px;
    display: flex;
    align-items: center;
}

.dropDown img {
    width: 15px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 30px;
    padding: 5px;
}

.option_card {
    padding: 10px 0;
    border-radius: 10px;
    background: #3D2E22;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
    overflow: hidden;
    width: 365px;
    font-size: 15px;
    color: #FFFFFF;
}

.option_row {
    padding: 10px;
}

.dropDownUp img {
    width: 15px;
    background: #FFFFFF;
    border-radius: 30px;
    padding: 5px;
}

#drop_down_id>>>.van-popover__arrow {
    border-bottom-color: transparent;
}

#drop_down_id>>>.van-popover__content {
    background: transparent;
}
</style>